import { Calendar, Tag, ThumbsUp, ChevronRight } from 'lucide-react';
import { ScammerReport } from '../lib/supabase';
import { HoodedFigureIcon } from './ReportIcons';

type ScammerCardProps = {
  report: ScammerReport & { profiles?: { username: string } };
  onClick: () => void;
};

export default function ScammerCard({ report, onClick }: ScammerCardProps) {
  return (
    <div onClick={onClick} className="group sf-card cursor-pointer active:scale-[0.98] sm:active:scale-100">
      <div className="p-3 sm:p-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 sm:w-10 sm:h-10 bg-ink-700 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-flag-700/30 transition border border-line">
            <HoodedFigureIcon size={22} />
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2 mb-1">
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-snow group-hover:text-flag-500 transition line-clamp-2 leading-snug">
                  {report.title}
                </h3>
                <p className="text-xs text-ash-400 mt-0.5 line-clamp-1">
                  <span className="font-semibold text-flag-500">{report.scammer_name}</span>
                  {report.real_name && <span className="text-ash-600 ml-1">({report.real_name})</span>}
                </p>
              </div>
              <ChevronRight className="w-4 h-4 text-ash-600 group-hover:text-flag-500 transition flex-shrink-0 mt-0.5" />
            </div>

            <div className="flex flex-wrap gap-1.5 mb-1.5">
              <span className="sf-badge bg-flag-500/15 text-flag-500 border border-flag-500/30">
                <Tag className="w-3 h-3" />{report.category}
              </span>
              <span className="sf-badge bg-ink-700 text-ash-400 border border-line">
                <Calendar className="w-3 h-3" />{new Date(report.created_at).toLocaleDateString()}
              </span>
              {report.upvote_count > 0 && (
                <span className="sf-badge bg-scan-500/15 text-scan-400 border border-scan-500/30">
                  <ThumbsUp className="w-3 h-3" />{report.upvote_count}
                </span>
              )}
            </div>

            <p className="text-xs text-ash-400 line-clamp-2 mb-1.5">{report.description}</p>

            <div className="flex items-center justify-between text-xs text-ash-400">
              <span className="truncate">View details</span>
              <span className="text-flag-500 font-medium group-hover:underline">View</span>
            </div>
          </div>
        </div>
      </div>
      <div className="sf-accent-bar bg-gradient-to-r from-scan-500 to-flag-500" />
    </div>
  );
}
